<template>
  <div v-if="!selecionouSegmento">
    <div
      class="icms-carga-liquida-perguntas-container"
      v-for="pergunta in imposto.perguntas"
      :key="pergunta.id_trib_cest"
    >
      <RadioButton
        :imposto="pergunta"
        :classe="imposto.classe"
        :seleciona="seleciona"
        :loading="loading"
      />
      <Registro>
        <Descricao :titulo="'Segmento'" :descricao="pergunta.segmento" />
        <div v-if="pergunta.segmento" class="separador" />

        <BaseLegal :base_legal="pergunta.base_legal" :classe="imposto.classe" />
      </Registro>
    </div>
  </div>

  <div v-else>
    <div class="icms-carga-liquida-perguntas-container">
      <EditButton
        v-if="imposto.perguntas.length > 1"
        :classe="imposto.classe"
        :edita="edita"
        :loading="loading"
      />
      <Registro :paddingSemCheckBox="imposto.perguntas.length == 1">
        <Descricao :titulo="'Segmento'" :descricao="segmentoSelecionado.segmento" />
        <div v-if="segmentoSelecionado.segmento" class="separador" />

        <BaseLegal :base_legal="segmentoSelecionado.base_legal" :classe="imposto.classe" />
      </Registro>
    </div>
  </div>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import EditButton from "@/components/Button/EditButton.vue";
import Inaplicabilidade from "@/components/Inaplicabilidade/Inaplicabilidade.vue";
import QuadroZebra from "@/components/QuadroZebra/QuadroZebra.vue";
import RadioButton from "@/components/Button/RadioButton.vue";
import Registro from "@/components/Registro/Registro.vue";
export default {
  name: "PerguntasIcmsCargaLiquida",

  props: {
    imposto: Array | Object,
    loading: Boolean,
    segmentoSelecionado: Object,
    seleciona: Function,
    selecionouSegmento: Boolean,
    edita: Function
  },

  components: {
    BaseLegal,
    Cabecalho,
    Descricao,
    EditButton,
    Inaplicabilidade,
    QuadroZebra,
    RadioButton,
    Registro
  },

  data() {
    return {};
  },

  created() {
    if (this.imposto && this.imposto.perguntas.length == 1) {
      this.seleciona(this.imposto.perguntas[0]);
    }
  },

  mounted() {},

  methods: {}
};
</script>

<style lang="scss" scoped>
.icms-carga-liquida-perguntas-container {
  display: flex;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
}
</style>
